module.exports = __webpack_public_path__ + "static/img/head-ar.3665d587.png";